import React from 'react';
import './Videodetail.scss';
import Rightbar from "../../components/Rightbar/Rightbar";
import Globals from "../../api";
import ReactHtmlParser from 'react-html-parser';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';


export default class VideoDetailPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          videoDetail: [],
          Rightbar : [],
          AdData : []
        };
      }
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
                
      } 
      getRightbar(){
        const url= Globals.Rightbar_api+"/latest-kannada-news";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }   
       
 componentDidMount() {
  const pathname = window.location.pathname;
  const videoId = pathname.split("/").filter(Boolean).pop();

  const apiURL =
    `https://ws-n.webdunia.com/json/Y-T-feed/get-video-detail?lang=kn&vid=${encodeURIComponent(videoId)}`;

  console.log("API URL:", apiURL);

  fetch(apiURL)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP error: ${res.status}`);
      }
      return res.json();
    })
    .then((data) => {
    //   console.log("Video details:", data);

      const videoDetail =
        data?.Contents?.find(
          (item) => item.Type === "VideoList"
        )?.Items || {};

      this.setState({
        videoDetail: videoDetail,
      });
    })
    .catch((error) => {
      console.error("Video API error:", error);
    });

  this.getRightbar();
}
   render() {
  const { videoDetail, loading } = this.state;

  if (loading) {
    return <div className="container padding15">Loading video...</div>;
  }

  const videoId = videoDetail.id || videoDetail.vid;
  const videoTitle = videoDetail.title || videoDetail.Title || "";
  const videoDescription =
    videoDetail.description || videoDetail.Description || "";

  return (
    <div className="container padding15">
      <div className="row">
        <div className="col">
          <div className="video_detai_wrap">
            <h2 className="video_title">{videoTitle}</h2>

            <div className="video_wraper"></div>

            <div id="video">
              {videoId && (
                <LiteYouTubeEmbed
                  id={videoId}
                  title={videoTitle || "Video"}
                  poster="hqdefault"
                  webp={true}
                  params="rel=0"
                />
              )}
            </div>

            <p>
              <b>{ReactHtmlParser(videoDescription)}</b>
            </p>
          </div>
        </div>

        <div className="col right_side_bar">
          <Rightbar
            Rightbar={this.state.Rightbar}
            googleAds={this.state.AdData}
          />
        </div>
      </div>
    </div>
  );
}
}